import { apiClient } from '../../api/client';
import { ApiResponse, PagedResponse } from '../../api/types';
import { DecisionLog, GeoRule, GeoRuleInput } from './types';

export async function listRules(): Promise<GeoRule[]> {
  const response = await apiClient.get<ApiResponse<GeoRule[]>>(
    '/api/v1/admin/geoblock/rules'
  );
  return response.data.data;
}

export async function createRule(input: GeoRuleInput): Promise<GeoRule> {
  const response = await apiClient.post<ApiResponse<GeoRule>>(
    '/api/v1/admin/geoblock/rules',
    input
  );
  return response.data.data;
}

export async function updateRule(
  id: number,
  input: GeoRuleInput
): Promise<GeoRule> {
  const response = await apiClient.put<ApiResponse<GeoRule>>(
    `/api/v1/admin/geoblock/rules/${id}`,
    input
  );
  return response.data.data;
}

export async function deleteRule(id: number): Promise<void> {
  await apiClient.delete(`/api/v1/admin/geoblock/rules/${id}`);
}

export async function listDecisionLogs(
  page: number,
  perPage: number
): Promise<PagedResponse<DecisionLog>> {
  const response = await apiClient.get<PagedResponse<DecisionLog>>(
    '/api/v1/admin/geoblock/decision-logs',
    {
      params: {
        page,
        per_page: perPage,
      },
    }
  );
  return response.data;
}
